__turbopack_context__.v({
  "container": "statsTile-module-scss-module__B2p2Qa__container",
  "downloadButton": "statsTile-module-scss-module__B2p2Qa__downloadButton",
  "downloadIcon": "statsTile-module-scss-module__B2p2Qa__downloadIcon",
  "emptyMessage": "statsTile-module-scss-module__B2p2Qa__emptyMessage",
  "search": "statsTile-module-scss-module__B2p2Qa__search",
  "searchInputField": "statsTile-module-scss-module__B2p2Qa__searchInputField",
  "tableWrapper": "statsTile-module-scss-module__B2p2Qa__tableWrapper",
  "tableWrapperOverride": "statsTile-module-scss-module__B2p2Qa__tableWrapperOverride",
});
